const second = 1000;
const minute = 60 * second;
const hour = 60 * minute;
const day = 24 * hour;

export function duration({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
  ms = 0,
}: {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  ms?: number;
}): number {
  return ms + seconds * second + minutes * minute + hours * hour + days * day;
}

export function toISOStringInTimeZone(
  timestamp: number,
  ianaTimeZone: string,
): string {
  const date = new Date(timestamp);

  // Format timestamp into `M/DD/YYYY, HH:MM:SS` string in target time zone and parse constituents:
  const tzDateString = date.toLocaleString('en-US', {
    timeZone: ianaTimeZone,
    hour12: false,
  });
  const [tzDate, tzTime] = tzDateString.split(', ');
  const [tzMonth, tzDay, tzYear] = tzDate.split('/');

  const utcString = `${tzYear}-${tzMonth.padStart(2, '0')}-${tzDay.padStart(
    2,
    '0',
  )}T${tzTime}.${date.getMilliseconds()}Z`;

  // Calculate the time zone offset between UTC and target time zone:
  const diffMinutes = Math.floor(
    (new Date(utcString).getTime() - date.getTime()) / (1000 * 60),
  );

  const tzSeparator = diffMinutes < 0 ? '-' : '+';
  const tzHour = Math.floor(Math.abs(diffMinutes) / 60);
  const tzMinute = Math.abs(diffMinutes) % 60;

  return `${utcString.split('Z')[0]}${tzSeparator}${tzHour
    .toString()
    .padStart(2, '0')}:${tzMinute.toString().padStart(2, '0')}`;
}

export function getTimePropertiesFromISOString(dateISOString: string): {
  dateTime: string;
  dateHour: string;
  hour: string;
} {
  return {
    dateHour: dateISOString.slice(0, 13).replace('T', '-'), // 2021-06-11-08
    dateTime: dateISOString, // 2021-06-11T08:15:19.953Z
    hour: dateISOString.slice(11, 13), // 08
  };
}

export function getAnalyticsTimeProperties(
  timestamp: number,
  ianaTimeZone: string,
): { dateTime: string; dateHour: string; hour: string } {
  return getTimePropertiesFromISOString(
    toISOStringInTimeZone(timestamp, ianaTimeZone),
  );
}
